import type { CatalogGridModelProps } from '@/components/catalog/catalog-grid/catalog-grid.model'
import { useCatalogGridModel } from '@/components/catalog/catalog-grid/catalog-grid.model'
import { CatalogGridView } from '@/components/catalog/catalog-grid/catalog-grid.view'

export function CatalogGridViewModel(props: CatalogGridModelProps) {
  const model = useCatalogGridModel(props)
  return <CatalogGridView {...model} />
}
